<template>
  <div>
    <NavBar />
    <main>
      <div class="max-w-7xl mx-auto py-6 px-3 sm:px-6 lg:px-8 flex flex-col gap-10">
        <Students />
      </div>
    </main>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import NavBar from '@/components/NavBar.vue'
import Students from '@/components/Students.vue'

export default defineComponent({
  name: 'App',
  components: { Students, NavBar },
  setup() {
  },
})
</script>

<style src="tailwindcss/tailwind.css" />
